export const MAX_FORM_WIDTH = '560px'
export const MAX_COLUMN_WIDTH = '266px'
export const COLUMN_WIDTH = '47.5%'
